import { parseJoinKey } from '../../shared/highentropy';
import { getAuthReady } from '../state/auth-state';
import { $ } from '../ui/dom';
import { showToast } from '../ui/toast';
import { promptJoin } from '../ui/high-entropy';

// Callback accessor so routing/hash.ts can call show() without importing main.ts.
let _hashShowCb: ((which: string) => void) | null = null;
export function setHashShowCb(fn: (which: string) => void){ _hashShowCb = fn; }

export function routeJoinHash(){
  if(!location.hash.startsWith('#/join/')) return false;
  const g = parseJoinKey(location.hash);
  history.replaceState(null, '', location.pathname + location.search);
  if(g) getAuthReady()!.then(() => promptJoin(g));
  else showToast('not a valid join link');
  return true;
}

export function routeJoinGroupHash(){
  const PREFIX = '#/join-group/';
  if(!location.hash.startsWith(PREFIX)) return false;
  const rest = location.hash.slice(PREFIX.length);
  history.replaceState(null, '', location.pathname + location.search);
  const slash = rest.indexOf('/');
  const g = slash >= 0 ? parseJoinKey(decodeURIComponent(rest.slice(0, slash))) : null;
  const invite = slash >= 0 ? decodeURIComponent(rest.slice(slash + 1)) : '';
  if(g && invite) getAuthReady()!.then(() => promptJoin(g, { invite }));
  else showToast('not a valid invite link');
  return true;
}

export function routeWorldHash(){
  if(location.hash !== '#/world') return false;
  if(!$('screen-world').classList.contains('is-active')) _hashShowCb?.('world');
  return true;
}

export function routeAdminHash(){
  if(location.hash !== '#/admin') return false;
  if(!$('screen-admin').classList.contains('is-active')) _hashShowCb?.('admin');
  return true;
}
